import { Common, ApiBind } from './common.model';

export class DeliverySetOsGroup extends Common {
  @ApiBind({ column: 'os_group_id' })
  id: number;
}
